module.exports = __webpack_public_path__ + "static/img/screenshot-mob.593429f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot-mob.png
// module id = AkL+
// module chunks = 0